/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import ReactPlayer from 'react-player/lazy'
import { AppContext } from '../AppContext'

class MediaPlayer extends React.Component
{
  componentDidMount()
  {
    if ('Y' === this.context.appLocalStorage.getAutoPlay()) this.setState({playing: true});
  }

  constructor(props)
  {
    super(props);

    this.state =
    {
      playing: false,
      url: props.url
    }

    this.stopPlayer = this.stopPlayer.bind(this);
    this.onPlay = this.onPlay.bind(this);
    this.props.setMediaRef(this);
  }

  onPlay(event)
  {
    this.setState({playing: true});
  }

  render()
  {
    if (null === this.props.url)
      return null;
    else
      return (
        <div className='player-wrapper'>
          <ReactPlayer className='react-player' width='100%' height='100%' url={this.state.url} controls={true} playing={this.state.playing} onPlay={this.onPlay}/>
        </div>
      );
  }

  stopPlayer()
  {
    this.setState({playing: false});
  }
}

MediaPlayer.contextType = AppContext;

export default MediaPlayer
